var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "w100 Overview" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.Loading,
              expression: "Loading",
            },
          ],
          staticClass: "search-top",
        },
        [
          _c(
            "div",
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "260px" },
                  attrs: {
                    filterable: "",
                    clearable: "",
                    placeholder: "请选择供应商",
                  },
                  model: {
                    value: _vm.SupplierId,
                    callback: function ($$v) {
                      _vm.SupplierId = $$v
                    },
                    expression: "SupplierId",
                  },
                },
                _vm._l(_vm.SupplierData, function (item) {
                  return _c("el-option", {
                    key: item.Id,
                    attrs: { label: item.title, value: item.Id },
                  })
                }),
                1
              ),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "10px" },
                  attrs: { type: "primary" },
                  on: { click: _vm.getDataList },
                },
                [_vm._v(" 查询")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.Loading,
              expression: "Loading",
            },
          ],
          staticClass: "table-ove",
          staticStyle: { width: "100%" },
          attrs: { data: _vm.Data, "header-row-class-name": "table-tit" },
        },
        [
          _c("el-table-column", {
            attrs: {
              type: "index",
              label: "序号",
              width: "55",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "SupplierName",
              label: "供应商名称",
              align: "center",
              width: "360",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "SubmissionRate",
              label: "提交率",
              align: "center",
              width: "200",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-progress", {
                      attrs: {
                        "text-inside": true,
                        "stroke-width": 16,
                        percentage: scope.row.SubmissionRate,
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "PassRate",
              label: "通过率",
              align: "center",
              width: "200",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-progress", {
                      attrs: {
                        "text-inside": true,
                        "stroke-width": 16,
                        percentage: scope.row.PassRate,
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "Num", label: "设备数量", align: "right" },
          }),
          _c("el-table-column", {
            attrs: { prop: "DocumentNum", label: "资料数量", align: "right" },
          }),
          _c("el-table-column", {
            attrs: { prop: "AccessoryNum", label: "配件数量", align: "right" },
          }),
          _c("el-table-column", {
            attrs: { prop: "RejectedQty", label: "提交数量", align: "right" },
          }),
          _c("el-table-column", {
            attrs: { prop: "PassQty", label: "通过数量", align: "right" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }